export function personalSummary(state, action) {
  return state;
}
